// src/modules/PackageManager/AddAppsTab.tsx
import React, { useState } from 'react';
import WingetTab from './WingetTab';
import CustomAppTab from './CustomAppTab';
import CurrentPackagesTab from './CurrentPackagesTab';

type AddMethod = 'winget' | 'current';

const AddAppsTab: React.FC = () => {
  const [activeMethod, setActiveMethod] = useState<AddMethod>('current');

  return (
    <div className="p-6 space-y-6">
      {/* Method Tabs */}
      <div className="flex gap-2 border-b border-gray-700">
        <button
          onClick={() => setActiveMethod('current')}
          className={`px-6 py-3 font-medium transition-colors ${
            activeMethod === 'current' ? 'text-red-500 border-b-2 border-red-500' : 'text-gray-400 hover:text-gray-300'
          }`}
        >
          Packages List
        </button>
        <button
          onClick={() => setActiveMethod('winget')}
          className={`px-6 py-3 font-medium transition-colors ${
            activeMethod === 'winget' ? 'text-red-500 border-b-2 border-red-500' : 'text-gray-400 hover:text-gray-300'
          }`}
        >
          Add Packages
        </button>
      </div>

      {/* Active Tab Content */}
      {activeMethod === 'current' && <CurrentPackagesTab />}

      {activeMethod === 'winget' && (
        <div className="grid grid-cols-2 gap-6">
          <WingetTab />
          <CustomAppTab />
        </div>
      )}
    </div>
  );
};

export default AddAppsTab;
